import { Component, OnDestroy, OnInit, inject } from '@angular/core';

import { HtmlNode } from '@frontend/vanilla/core';

/**
 * @description Adds standalone css class to html node and displays content with dlg-responsive css class
 *
 * @stable
 */
@Component({
    selector: 'lh-cross-product-layout',
    templateUrl: 'cross-product-layout.component.html',
})
export class CrossProductLayoutComponent implements OnInit, OnDestroy {
    private htmlNode = inject(HtmlNode);

    ngOnInit(): void {
        this.htmlNode.setCssClass('standalone', true);
    }

    ngOnDestroy(): void {
        this.htmlNode.setCssClass('standalone', false);
    }
}
